import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ISearchAppState } from '../../reducers/index'
import { FacetTerm } from './facet-term'
import { IFacetResult, ITerm, IFacets } from '../../state-helpers/facets';
import { IEpiProps } from '../../state-helpers/epi-props';
import * as _ from 'lodash';
import { addUrlProps, UrlQueryParamTypes, subquery } from 'react-url-query';
import { resultsModel } from '../../reducers/results-model';
import { pushInUrlQuery } from 'react-url-query';
import { updatedSelectedFacetCount } from '../../reducers/facets-model';
import { setSort, setMobileFacetsVisibility, setFacetDropdownVisibility } from '../../actions/index';
import { ToggleFacetTerm } from './toggle-facet-term';
import { MultiselectDropdownFacetSection } from './multiselect-dropdown-facet-section';
import { FacetSection } from './facet-section';
import { IAnalytics } from '../../../global/functions/analytics';
import { DropdownSelect } from '../../../global/components/inputs/selects/dropdown-select'
import { IDropdownOption, defaultDivider } from '../../../global/state-helpers/filters';
import { Dropdown } from '../../../my-account/components/input-edits/security-question-edit';
import { FieldNames } from '../../state-helpers/facets';
import { DropdownFacet } from '../../../global/components/inputs/filters/dropdown-facet';
import { forEach } from 'lodash';

interface StatesModel {
    id: string;
    display: string;
    selected: boolean;
}

//Determines how to render Facets
export enum RenderTemplate {
    DEFAULT,
    ONLINE_ONLY,
    STATES,
    IS_RETIRED,
    NONE,
    DROPDOWN
}

const USA_OPTION_ID = 'USA';
const INTL_OPTION_ID = 'International';
const IS_RETIRED_ID = 'IsRetired';
const ONLINE_ONLY_ID = 'Online Only';

interface IStateProps {
    facetsHeaderText: string;
    facetsResetLinkText: string;
    noFacetsText: string;

    facets: IFacetResult[];

    selectedFacetCount: number;

    isLoading: boolean;
    dropdownVisibility: boolean;
    mobileFacetsVisibility: boolean;

    epiProps: IEpiProps;
}

interface IDispatchProps {
    setSort: (sortId: string) => void;
    setFacetDropdownVisibility: (visible: boolean) => void;
    setMobileFacetsVisibility: (visible: boolean) => void;
}

interface IOwnProps {
    analytics: IAnalytics;
    onUpdateSearchFacet: (facets: IFacetResult[]) => void;
}

type IProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {

}

export class Facets extends React.Component<IProps, IState> {
    // Properties
    get hasVisibleFacets() {
        return this.props.facets.some(f => f.terms.some(t => t.hits > 0 && t.term.length > 0));
    }

    // Render methods
    render() {
        const { facets, selectedFacetCount, isLoading, facetsHeaderText, facetsResetLinkText, noFacetsText } = this.props;

        return (
            <div className={'search-facet ' + (this.props.mobileFacetsVisibility ? 'active' : '')}>

                {isLoading && <div className="search-facet-loading"></div>}
                <div className="search-facet-header">
                    <div className="search-facet-header-mobile" onClick={this.onToggleMobileFacets}>
                        <svg className="open">
                            <use xlinkHref="#icon-refine"></use>
                        </svg>
                        <svg className="close">
                            <use xlinkHref="#icon-close"></use>
                        </svg>
                    </div>
                    <h4 className="search-facet-header-title">{facetsHeaderText}</h4>
                    <span className="search-facet-header-selected-count">{selectedFacetCount}</span>
                    <div className="search-facet-header-clear" onClick={this.onResetFacets}><u>{facetsResetLinkText}</u></div>
                </div>

                <div className="search-facet-terms">
                    {/*Map props to object and check template on facet*/}
                    {facets && this.orderFacets(facets).map((facet, index) =>
                        <React.Fragment
                            key={"facet" + index}>{this.renderFacet(facet, index)}
                        </React.Fragment>)}
                    {/*If no visible facets, display a message*/}
                    {(!this.props.isLoading && !this.hasVisibleFacets)
                        ? <div className="search-facet-msg-empty">{noFacetsText}</div>
                        : null
                    }
                </div>

            </div>
        );
    }

    renderFacet = (facet: IFacetResult, index: number) => {
        if (!facet.terms.some(t => t.hits > 0 && t.term.length > 0)) {
            return;
        }

        if ((window as any).bootstrap.hideLanguageFilter && facet.name == "Language") {
            return;
        }

        switch (facet.renderTemplate) {
            case RenderTemplate.ONLINE_ONLY:
                return this.renderToggleFacetSection(facet, index);
            case RenderTemplate.IS_RETIRED:
                return this.renderToggleFacetSection(facet, index);
            case RenderTemplate.STATES:
                return this.renderMultiselectDropdownFacetSection(facet, index);
            case RenderTemplate.NONE:
                return;
            case RenderTemplate.DROPDOWN:
                return this.renderDropdownFacetSection(facet, index);
            default:
                return this.renderFacetSection(facet, index);
        }
    }
    orderFacets = (facets: IFacetResult[]) => {
        const { epiProps } = this.props;
        if (epiProps.facetOrder == null || epiProps.facetOrder.length == 0 ) {
            return facets
        }
        let sortFacetArray = [...epiProps.facetOrder]
        let facetsToSort = [...facets]
        let result = []
        for (let i = 0; i < sortFacetArray.length; i++) {
            for (var j = 0; j < facetsToSort.length; j++) {
                if (sortFacetArray[i].toLowerCase() == facetsToSort[j].name.toLowerCase()) {
                    result.push(facetsToSort[j]);
                    facetsToSort.splice(facetsToSort.indexOf(facetsToSort[j]), 1)
                    break;
                }
            }
        }
        return result.concat(facetsToSort);
    }
    renderDropdownFacetSection = (facet: IFacetResult, index: number) => {
        const { onUpdateSearchFacet, epiProps } = this.props;

        return <DropdownFacet
            facet={facet}
            facets={this.props.facets}
            index={index}
            pinnedCountryNames={epiProps.pinnedCountryNames}
            pinnedSubspecialties={epiProps.pinnedSubspecialties}
            onUpdateSearchFacet={onUpdateSearchFacet}
            key={facet.name + "-" + index}
            removeSelectText={true}
        />       
    }

    getDisabled = (currentFacet: IFacetResult) => {
        if (currentFacet.fieldName.toLowerCase() === FieldNames.States) {
            let countries = this.props.facets.filter(f => f.fieldName.toLowerCase() === FieldNames.Countries)[0];
            return countries && countries.terms.some(t => t.selected) ? false : true;
        }
        return false;
    }

    getDropdownSelected = (id: string, facet: IFacetResult, f: IFacetResult, t: ITerm) => {
        // If this is the current term, toggle it
        if (t.id === parseInt(id)) {
            return !t.selected;
        }
        // if countries is set to placeholder, unselect states 
        if ((f.fieldName.toLowerCase() === FieldNames.States && facet.fieldName.toLowerCase() === FieldNames.Countries && !id)
            //or if this is a term in the current facet, set it to off
            || f.fieldName === facet.fieldName) {
            return false;
        }
        // Otherwise leave as is
        return t.selected;
    }

    getDropdownTerms = (id: string, facet: IFacetResult, f: IFacetResult) => {
        if (id === '' && f.fieldName === facet.fieldName) {
            return [];
        }

        return f.terms.map(t => ({
            ...t,
            selected: this.getDropdownSelected(id, facet, f, t)
        }))
    }

    mapDropdownFacets = (id: string, facet: IFacetResult) => {
        return this.props.facets.map(f => ({
            ...f,
            // Reset the terms for this facet when the placeholder is chosen
            terms: this.getDropdownTerms(id, facet, f)
        }));
    }

    renderToggleFacetSection = (facet: IFacetResult, index: number) => {
        const { facets, onUpdateSearchFacet } = this.props;

        const toggleTerm = facet.terms.filter(t => t.term == ONLINE_ONLY_ID || t.term == IS_RETIRED_ID)[0];
        return (
            <>{toggleTerm &&
                <ToggleFacetTerm
                key={toggleTerm.id }
                term={toggleTerm}
                onTermClick={() => this.onToggleTerm(toggleTerm)}
                showHits={toggleTerm == null || toggleTerm.term != IS_RETIRED_ID} />
                }
            </>
        )
    }

    renderMultiselectDropdownFacetSection = (facet: IFacetResult, index: number) => {
        const { facets, dropdownVisibility, onUpdateSearchFacet } = this.props;

        // Do this different
        const states = (window as any).bootstrap.states as StatesModel[];

        const dropdownTerms = facet.terms.map(t => ({
            id: t.id,
            to: t.to,
            from: t.from,
            hits: t.hits,
            selected: t.selected,
            alwaysShow: t.alwaysShow,
            term: (states.filter(s => s.id === t.term)[0] || { display: '' }).display
        }) as ITerm)

        const checkboxOptions = facets.filter(f => f.name == USA_OPTION_ID || f.name === INTL_OPTION_ID);
        const selectedItems = dropdownTerms.filter(d => d.selected).length
        const summary = selectedItems > 0 ? selectedItems + ' states(s) selected' : 'Select States';

        return (
            <MultiselectDropdownFacetSection
                key={index}
                summaryText={summary}
                facet={facet}
                checkboxFacets={checkboxOptions}
                dropdownTerms={dropdownTerms}
                dropdownVisible={dropdownVisibility}
                onToggleMenu={this.onToggleDropdownMenu}
                onToggleTerm={this.onToggleTerm}
                onSelectAllFacetTerms={this.onSelectAllFacetTerms}
                onClearAllFacetTerms={this.onClearAllFacetTerms} />
        )
    }

    renderFacetSection = (facet: IFacetResult, index: number) => {
        const { facets, onUpdateSearchFacet } = this.props;

        return (
            <FacetSection
                key={index}
                facet={facet}
                onToggleTerm={this.onToggleTerm} />
        )
    }

    // Event handlers
    onToggleTerm = (term: ITerm) => {

        this.props.analytics.onFacetToggle(term.term, !term.selected);

        const facets = this.props.facets.map(f => ({
            ...f,
            terms: f.terms.map(t => ({
                ...t,
                selected: t.id === term.id ? !t.selected : t.selected
            }))
        }))
        this.props.onUpdateSearchFacet(facets);
    }

    onSelectAllFacetTerms = (facet: IFacetResult) => {

        this.props.analytics.onFacetToggle(`All ${facet.name}`, true);

        const facets = this.props.facets.map(f => ({
            ...f,
            terms: f.terms.map(t => ({
                ...t,
                selected: t.selected || f.name === facet.name
            }))
        }))
        this.props.onUpdateSearchFacet(facets);
    }

    onClearAllFacetTerms = (facet: IFacetResult) => {

        this.props.analytics.onFacetToggle(`All ${facet.name}`, false);

        const facets = this.props.facets.map(f => ({
            ...f,
            terms: f.terms.map(t => ({
                ...t,
                selected: f.name === facet.name ? false : t.selected
            }))
        }))
        this.props.onUpdateSearchFacet(facets);
    }

    onToggleMobileFacets = () => {
        const { setMobileFacetsVisibility, mobileFacetsVisibility } = this.props;
        setMobileFacetsVisibility(!mobileFacetsVisibility);
    }

    onToggleDropdownMenu = () => {
        const { setFacetDropdownVisibility, dropdownVisibility } = this.props;
        setFacetDropdownVisibility(!dropdownVisibility);
    }

    onResetFacets = () => {
        const { facets, onUpdateSearchFacet } = this.props;

        const newFacets = facets.map(f => ({
            ...f,
            terms: f.terms.map(t => ({
                ...t,
                selected: false
            }))
        }))

        onUpdateSearchFacet(newFacets);
    }
}

// Mappings
const mapStateToProps = (state: ISearchAppState): IStateProps => ({
    facetsHeaderText: state.epiPropsModel.facetsHeaderText,
    facetsResetLinkText: state.epiPropsModel.facetsResetLinkText,
    noFacetsText: state.epiPropsModel.noFacetsText,
    facets: state.facetsModel.facets,
    isLoading: state.resultsModel.loading,
    selectedFacetCount: state.facetsModel.selectedFacetCount,
    dropdownVisibility: state.facetsModel.dropdownVisible,
    mobileFacetsVisibility: state.facetsModel.mobileFacetsVisible,
    epiProps: state.epiPropsModel
})

const mapDispatchToProps = (dispatch): IDispatchProps => {
    return bindActionCreators({
        setSort,
        setFacetDropdownVisibility,
        setMobileFacetsVisibility
    }, dispatch);
}

export const ConnectedFacets = connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(Facets);